import React, { useState } from "react";

import CancelButton from "../../../components/CancelButton";
import SaveButton from "../../../components/SaveButton";

import {
  cpf as cpfMask,
} from "../../../constants/validate";

const EditableRow = ({
  editFormData,
  handleEditFormChange,
  handleCancelClick,
  handleEditFormSubmit,
}) => {

  const options = [
    { value: '', text: '--Escolha uma opção--' },
    { value: 0, text: 'Não' },
    { value: 1, text: 'Sim' },
  ];

  const [selected, setSelected] = useState("");

  function handleSetSelected(value){
    setSelected(value);
  }

  const handleChange = event => {
    event.preventDefault();
    
    handleSetSelected(event.target.value);

    editFormData.blocked = event.target.value;
  };

  return (
    <tr>
      <td>
        <input
          type="text"
          required="required"
          placeholder="Enter a name..."
          name="name"
          value={editFormData.name}
          onChange={handleEditFormChange}
        ></input>
      </td>
      <td>
        <input
          type="text"
          required="required"
          placeholder="Enter an cpf..."
          name="cpf"
          value={cpfMask(editFormData.cpf)}
          onChange={handleEditFormChange}
          maxLength={14}
        ></input>
      </td>
      <td>
        <input
          type="email"
          required="required"
          placeholder="Enter an email..."
          name="email"
          value={editFormData.email}
          onChange={handleEditFormChange}
        ></input>
      </td>
      <td>
        <select value={selected} onChange={handleChange}>
          {options.map((item) => (
            <option key={item.value} value={item.value}>
              {item.text}
            </option>
          ))}
        </select>
      </td>
      <td>
        <SaveButton onClick={(event) => handleEditFormSubmit(event)}>Save</SaveButton>
        <CancelButton onClick={handleCancelClick}></CancelButton>
      </td>
    </tr>
  );
};

export default EditableRow;
